import axios from "axios";
import authHeader from "./auth_header";
import * as CONST from './common'

const API_URL = CONST.API_URL;



const getPaymentLink = (subscription_plan_id, months, type) => {
    if (months === undefined) {
        months = 1;
    }
    if (type === undefined) {
        type = 'default'
    }
    return axios.get(API_URL + 'subscription/payment_link?subscription_plan_id=' + subscription_plan_id + '&months=' + months + '&type=' + type, { headers: authHeader() })
}

const getSubscriptionPlans = () => {
    return axios.get(API_URL + 'subscription/subscription_plans', { headers: authHeader() })
}

const cancel = () => {
    return axios.post(API_URL + 'subscription/cancel_subscription', {}, { headers: authHeader() });
}

export default {
    getSubscriptionPlans,
    getPaymentLink,
    cancel
};